module.exports = __webpack_public_path__ + "images/views-upsell/dashboard.7c8d3d1ba947aa563852.svg";